<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card
        :class="getExpireAt | untilExpire | expireColor"
        :color="
          info.color
            ? info.color === 'green'
              ? '#44ff002e'
              : '#ffa5003d'
            : null
        "
        class="d-md-flex px-4 py-3 align-center qr-card-wrapper"
        elevation="4"
      >
        <v-card-actions
          :class="{
            'show-checkbox': showCheck,
            disabled:
              !!info?.data?.data?.auto_id && info?.data?.data?.auto_id !== null,
          }"
          class="action-select pa-0 pa-md-2"
        >
          <v-checkbox
            v-model="checkbox"
            class="ma-0"
            color="primary"
            dense
            hide-details
          />
          <v-spacer />
          <div v-if="isMobile" class="pa-0 rowinfo" style="width: 100%">
            <div
              class="contentinfo position-relative"
              style="top: 0px; width: 100%"
            >
              <renew-button
                :badge-text="renewBadgeText"
                :badge-color="renewBadgeColor"
                :button-color="renewButtonColor"
                :scale="0.72"
                :loading="priceLoading"
                class="full-width-btn"
                @click="getPrices"
                :badgeOffsetY="7"
                :buttonText="$t('assistantChatViewer.renew')"
              />
            </div>
          </div>
        </v-card-actions>
        <v-card-text
          :class="{
            disabled:
              !!info?.data?.data?.auto_id && info?.data?.data?.auto_id !== null,
          }"
          class="py-2 py-md-0 w-fit-content mx-auto"
        >
          <v-tooltip
            v-if="
              (!info.img_url || !info.image)
            "
            top
          >
            <template v-slot:activator="{ on, attr }">
              <v-btn
                :href="
                  ['qrLink','clickyarseo'].includes(info?.type?.trim())
                    ? `#/qr/design2/${!!info.qrId?.replace('?gateway=true','') ? info.qrId?.replace('?gateway=true','') : ''}`
                    : `#/qr/design/${info?.domain?.name}${
                        !!info?.identifier ? info?.identifier : ''
                      }`
                "
                class="rounded-lg px-0"
                color="warning"
                depressed
                min-width="112"
                target="_blank"
                v-bind="attr"
                v-on="on"
              >
                <v-icon>mdi-image-refresh</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("regenerate_image") }}</span>
          </v-tooltip>
          <div
            v-if="
              !(
                info.extra_short &&
                info.extra_short.id &&
                (!info.img_url || !info.image)
              )
            "
            class="img-wrapper"
            style="position: relative; display: inline-block"
          >
            <div
              v-if="isImageLoading && imageLoadingFromParent"
              class="nfc-loading-overlay"
              style="
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: rgba(255, 255, 255, 0.9);
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 8px;
                z-index: 10;
              "
            >
              <div class="text-center">
                <v-progress-circular
                  color="primary"
                  indeterminate
                  size="40"
                  width="3"
                ></v-progress-circular>
                <div class="mt-2 text-caption text-grey-darken-1">
                  {{ $t("updating_qr") }}
                </div>
              </div>
            </div>
            <v-img
              :lazy-src="getImage"
              :max-height="isMobile ? '230' : '112'"
              :max-width="isMobile ? '155' : '112'"
              :min-width="isMobile ? '155' : '112'"
              :src="getImage"
              contain
              eager
              @error="onImageError"
              @loaded="onImageLoad"
            >
              <template v-slot:placeholder>
                <v-row align="center" class="fill-height ma-0" justify="center">
                  <v-progress-circular
                    v-if="isImageLoading && !imageLoadingFromParent"
                    color="primary"
                    indeterminate
                    size="32"
                    width="3"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </div>
        </v-card-text>

        <v-card-text
          :class="{
            disabled:
              !!info?.data?.data?.auto_id && info?.data?.data?.auto_id !== null,
          }"
          class="pa-0"
        >
          <v-card-subtitle class="pa-0 ms-10">
            {{ info.type | qrType("name") }}
          </v-card-subtitle>
          <div class="font-size-h6 font-weight-bold">
          <v-badge
          v-if="$options.filters.qrType(info.type, 'pro')"
          color="transparent"
          overlap
          offset-x="23"
          offset-y="10"
        >
          <template #badge>
            <v-icon color="grey darken-3" size="13" class="glow-crown">mdi-crown</v-icon>
          </template>
          <img 
            v-if="displayMap[info.type] && displayMap[info.type].type === 'image'" 
            :src="displayMap[info.type].src" 
            width="32" 
            height="32" 
            class="me-2 icon-list-type"
            style="object-fit: contain; vertical-align: middle;"
          ></img>
          <v-icon v-else class="me-2 icon-list-type" color="grey darken-3" size="32">mdi-{{ info.type | qrType("icon") }}</v-icon>
        </v-badge>
        <template v-else>
          <img 
            v-if="displayMap[info.type] && displayMap[info.type].type === 'image'" 
            :src="displayMap[info.type].src" 
            width="32" 
            height="32" 
            class="me-2 icon-list-type"
            style="object-fit: contain; vertical-align: middle;"
          ></img>
          <v-icon v-else class="me-2 icon-list-type" color="grey darken-3" size="32">mdi-{{ info.type | qrType("icon") }}</v-icon>
        </template>
            <div
             v-if="!editTitle"
              class="d-inline-flex align-center"
              style="height: 40px; max-width: calc(100% - 40px);"
            >
              <span class="d-inline-block text-truncate" style="max-width: 150px;">
                {{ info.title }}
              </span>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    @click="editTitle = true"
                  >
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("edit") }}</span>
              </v-tooltip>
            </div>
            <v-card
              v-else
              v-click-outside="onCloseField"
              class="d-inline-block"
              flat
              max-width="250"
            >
              <div class="rowinfo" style="width: 100% !important">
                <v-text-field
                  v-model="editedName"
                  :disabled="permissionState.edit_name"
                  :error-messages="errorMessage"
                  :hide-details="!errorMessage"
                  :loading="loading"
                  append-icon="check"
                  autofocus
                  class="contentinfo"
                  clearable
                  dense
                  outlined
                  @click:append="updateTitle"
                  @click:clear="onCloseField"
                  @keydown.enter="updateTitle"
                />
              </div>
            </v-card>
          </div>

          <div class="pt-2 desc-text w-fit-content cursor-pointer">
            <v-icon class="ms-1 me-3" size="22">mdi-link-variant</v-icon>

            <v-tooltip v-model="showTooltip" color="green darken-1" top  v-if="!!displayLink && displayLink?.trim()!==''">
              <template v-slot:activator="{ on, attrs }">
                <a 
                  :href="validHref" 
                  target="_blank" 
                  v-bind="attrs" 
                  v-on="on"
                  class="d-inline-block text-truncate"
                  style="max-width: 200px; vertical-align: middle;"
                >
                  {{ displayLink }}
                </a>
              </template>
              <span>{{ $t("copied") }}</span>
          </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small v-bind="attrs" @click="copyUrl" v-on="on">
                  <v-icon small>mdi-content-copy</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("copy") }}</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  v-bind="attrs"
                  @click="$emit('print-qr', info)"
                  v-on="on"
                >
                  <v-icon small>mdi-printer-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("print_qr") }}</span>
            </v-tooltip>

            <v-tooltip v-if="['VisitCard','visitcardpro'].includes(info.type)" color="info" top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :href="gotoGraphic"
                  class="ms-1"
                  color="info"
                  icon
                  small
                  target="_blank"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon small>mdi-card-account-phone-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("print_visit_card") }}</span>
            </v-tooltip>

            <v-tooltip color="warning" top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :href="qrSmsLink"
                  class="ms-1"
                  color="warning"
                  icon
                  small
                  target="_blank"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon small>mdi-cellphone-message</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("send_link") }}</span>
            </v-tooltip>
            <v-tooltip v-if="['wheel'].includes(info?.type?.toLowerCase())" top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  v-bind="attrs"
                  @click="
                    $emit('show', {
                      info: info,
                      type: 'wheel_winner_list',
                    })
                  "
                  v-on="on"
                >
                  <v-icon small>mdi-trophy</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("winner_list") }}</span>
            </v-tooltip>
            <v-tooltip v-if="['attendanceqr'].includes(info?.type?.toLowerCase())" top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                small
                v-bind="attrs"
                @click="
                  $emit('show', {
                    info: info,
                    type: 'employee_list',
                  })
                "
                v-on="on"
              >
                <v-icon small color="primary">mdi-account-group-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ "لیست پرسنل" }}</span>
          </v-tooltip>
          <v-tooltip v-if="['attendanceqr'].includes(info?.type?.toLowerCase())" top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                small
                v-bind="attrs"
                @click="
                  $emit('show', {
                    info: info,
                    type: 'attendace_list',
                  })
                "
                v-on="on"
              >
                <v-icon small color="info">mdi-clipboard-clock-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ "لیست تردد" }}</span>
          </v-tooltip>
          <v-tooltip v-if="['attendanceqr'].includes(info?.type?.toLowerCase())" top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                small
                :loading="downLoading"
                :disabled="downLoading"
                v-bind="attrs"
                @click="
                  downloadExcel
                "
                v-on="on"
              >
                <v-icon small color="success">mdi-file-excel-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ "خروجی اکسل" }}</span>
          </v-tooltip>

            <v-tooltip
              v-if="
                ['menu', 'appointment', 'bshop', 'wheel', 'multicard'].includes(
                  info?.type?.toLowerCase(),
                )
              "
              top
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="permissionState.view_customers"
                  icon
                  small
                  v-bind="attrs"
                  @click="
                    $emit('show', {
                      info: info,
                      type: 'users',
                    })
                  "
                  v-on="on"
                >
                  <v-icon small>mdi-account-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("customer_list") }}</span>
            </v-tooltip>

            <v-tooltip
              v-if="['menu', 'bshop'].includes(info?.type?.toLowerCase())"
              top
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="permissionState.view_orders"
                  icon
                  small
                  v-bind="attrs"
                  @click="$emit('show', { info, type: 'orders' })"
                  v-on="on"
                >
                  <v-icon small>mdi-basket-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("order_list") }}</span>
            </v-tooltip>

            <v-tooltip v-if="info.type === 'appointment'" top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  v-bind="attrs"
                  @click="$emit('show', { info, type: 'appointments' })"
                  v-on="on"
                >
                  <v-icon small>mdi-calendar-multiple-check</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("reserved_appointments") }}</span>
            </v-tooltip>
            <v-tooltip
              v-if="
                [
                  'menu',
                  'insurance',
                  'appointment',
                  'cshop',
                  'bshop',
                  'commericial',
                  'business',
                  'labelproduct',
                  'feedbackgallery',
                  'productpro',
                  'visitcardpro'
                ].includes(info?.type?.toLowerCase())
              "
              top
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  v-bind="attrs"
                  @click="$emit('show', { info, type: 'feedback' })"
                  v-on="on"
                >
                  <v-icon small>mdi-reply-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("feedback") }}</span>
            </v-tooltip>

            <v-tooltip v-if="info?.type?.toLowerCase() === 'multicard'" top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="ms-1"
                  icon
                  small
                  v-bind="attrs"
                  @click="
                    $emit('show', {
                      info,
                      type: 'transactions',
                    })
                  "
                  v-on="on"
                >
                  <v-icon small>mdi-bank</v-icon>
                </v-btn>
              </template>
              <!--              <span>{{ $t("select_nfc_card") }}</span>-->
              <span>مدیریت تراکنش ها</span>
            </v-tooltip>

            <v-tooltip
              v-if="
                [
                  'menu',
                  'photogallery',
                  'insurance',
                  'appointment',
                  'cshop',
                  'commericial',
                  'VisitCard',
                  'visitcardpro',
                  'bshop',
                  'business',
                  'labelproduct',
                  'consultationqr',
                  'productpro',
                ].includes(info?.type?.toLowerCase())
              "
              top
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  v-bind="attrs"
                  @click="$emit('show', { info, type: 'form' })"
                  v-on="on"
                >
                  <v-icon small>mdi-list-box-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("request_form") }}</span>
            </v-tooltip>

            <v-tooltip v-if="info?.type?.toLowerCase() !== 'multicard'" top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="permissionState.qr_id"
                  icon
                  small
                  v-bind="attrs"
                  @click="$emit('show', { info, type: 'ownership' })"
                  v-on="on"
                >
                  <v-icon small>mdi-account-key-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("transfer_ownership") }}</span>
            </v-tooltip>
            <v-tooltip v-if="info.type === 'bShop'" top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  v-bind="attrs"
                  @click="bshop_mang_pop = true"
                  v-on="on"
                >
                  <v-icon small>mdi-store</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("store_management") }}</span>
            </v-tooltip>

            <v-tooltip v-if="choseNfc()" top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="ms-1"
                  icon
                  small
                  v-bind="attrs"
                  @click="$emit('show', { info, type: 'nfc' })"
                  v-on="on"
                >
                  <v-icon small>mdi-nfc</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("select_nfc_card") }}</span>
            </v-tooltip>

            <!-- <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="ms-1"
                  :disabled="permissionState.qr_id"
                  icon
                  small
                  @click="
                    !permissionState.qr_id &&
                      goto(
                        `qr/list/commercial/${info.domain?.name}${
                          !!info?.identifier ? info?.identifier : ''
                        }`
                      )
                  "
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon small>mdi-handshake</v-icon>
                </v-btn>
              </template>

              <span> مشارکت</span>
            </v-tooltip> -->
          </div>

          <div class="d-flex align-center" style="gap: 8px">
            <v-tooltip top>
              <template v-slot:activator="{ on, attr }">
                <div
                  class="pt-2 desc-text w-fit-content"
                  v-bind="attr"
                  v-on="on"
                >
                  <v-icon class="ms-1 me-3" size="22">mdi-clock-outline</v-icon>
                  {{ info.created_at_diff }}
                </div>
              </template>
              <span style="font-size: 0.8em">
                {{ $t("created_at") }}: {{ dateString(info.created_at) }}
              </span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attr }">
                <div
                  class="pt-2 desc-text w-fit-content"
                  v-bind="attr"
                  v-on="on"
                >
                  <v-icon class="ms-1 me-3" size="22"
                    >mdi-pencil-outline
                  </v-icon>
                  {{ info.updated_at_diff }}
                </div>
              </template>
              <span style="font-size: 0.8em">
                {{ $t("last_edit") }}: {{ dateString(info.updated_at) }}
              </span>
            </v-tooltip>
          </div>
        </v-card-text>
        <v-divider
          v-if="
            isMobile &&
            !!info?.data?.data?.auto_id &&
            info?.data?.data?.auto_id !== null
          "
        />
        <v-spacer
          v-if="
            !isMobile &&
            !!info?.data?.data?.auto_id &&
            info?.data?.data?.auto_id !== null
          "
        />
        <div
          v-if="
            !!info?.data?.data?.auto_id && info?.data?.data?.auto_id !== null
          "
          style="width: 100%"
        >
          <progress_createauto :info="info" />
          <!-- <v-divider v-if="isMobile" />
        <v-spacer v-else />
        <div style="width: 100%">
          <Progress_createauto :info="info" /> -->
        </div>
        <v-divider v-if="isMobile" />
        <v-spacer v-else />

        <v-card-text
          :class="{
            disabled:
              !!info?.data?.data?.auto_id && info?.data?.data?.auto_id !== null,
          }"
          class="pa-0 w-fit-content text-md-left"
        >
          <div
            :style="
              !isMobile
                ? 'justify-content: end !important; justify-items: flex-end'
                : 'justify-content: start !important; justify-items: flex-start'
            "
            class="rowinfo"
          >
            <help-info
              :element-name="`${serviceName}-${componentName}-cardlsituser`"
              :help-data="helpData"
              :label="$t('qr_card')"
              :service-name="serviceName"
              class="buttoninfo"
            />
          </div>
          <div class="mx-2">
            <span class="font-size-h6 font-weight-bold">{{
              info.clicks || 0 | persianNum
            }}</span>
            <br />
            {{ $t("viewed") }}
            <br />
            <v-btn
              class="px-2 mx-n2"
              color="primary"
              small
              text
              @click="
                ['qrLink','clickyarseo'].includes(info?.type?.trim())
                  ? goto(`qr/statistics2/${info.qrId?.replace('?gateway=true','')}`)
                  : goto(
                      `qr/statistics/${info.domain?.name}${
                        !!info.identifier ? info.identifier : ''
                      }`,
                    )
              "
            >
              <v-icon :style="isMobile ? 'order: 2' : ''" class="me-1" small>
                mdi-chevron-{{ isMobile ? "left" : "right" }}
              </v-icon>
              {{ $t("see_more") }}
            </v-btn>
          </div>
        </v-card-text>

        <v-divider :vertical="!isMobile" class="ma-md-4" />

        <v-card-actions
          :class="{
            disabled:
              !!info?.data?.data?.auto_id && info?.data?.data?.auto_id !== null,
          }"
          class="position-relative flex-wrap pa-0"
        >
          <!-- <div
            v-if="!isMobile"
            :style="
              !isMobile
                ? 'width: 100%; top: 0px; position: absolute'
                : 'width: 100%;'
            "
            class="pa-0"
          >
            <div
              v-if="!isMobile"
              :class="getExpireAt | untilExpire | expireColor"
              class="expire-option btn"
              @click="getPrices"
            >
              <v-progress-circular
                v-if="priceLoading"
                indeterminate
                size="20"
                width="2"
              />
              <div v-else>
                <v-icon color="white" small>mdi-timer-refresh-outline</v-icon>
                {{ getExpireAt | untilExpire | typeText }}
              </div>
            </div>
          </div> -->
          <div
            v-if="!isMobile"
            style="width: 100%; top: -40px; position: absolute"
            class="pa-0 d-flex justify-center"
          >
            <renew-button
              :badge-text="renewBadgeText"
              :badge-color="renewBadgeColor"
              :button-color="renewButtonColor"
              :scale="0.75"
              :loading="priceLoading"
              @click="getPrices"
              :badgeOffsetY="7.5"
              :buttonText="$t('assistantChatViewer.renew')"
            />
          </div>
          <div
            v-if="info.status === 'active'"
            :block="isMobile"
            :style="
              isMobile &&
              hasValidHelpinfo(`${serviceName}-${componentName}-btn-Dwnload`)
                ? 'order: 1; direction: ltr;'
                : isMobile
                ? 'order: 1; direction: ltr;'
                : ''
            "
            class="pa-0 d-flex row rowinfo align-center"
          >
            <v-btn
              v-if="info.status === 'active'"
              :block="isMobile"
              :style="isMobile ? 'order: 1;' : ''"
              class="contentinfo"
              color="primary"
              min-width="100"
              outlined
              @click="$root.$emit('fillInfo', info)"
            >
              {{ $t("download") }}
              <v-icon class="ms-1" small>mdi-download</v-icon>
            </v-btn>
            <!-- <help-info
                :element-name="`${serviceName}-${componentName}-btn-Dwnload`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="دانلود"
              /> -->
          </div>
          <div
            v-else
            :block="isMobile"
            :style="isMobile ? 'order: 1' : ''"
            class="pa-0 rowinfo align-center"
          >
            <v-btn
              :block="isMobile"
              :disabled="permissionState.toggle_access"
              :style="isMobile ? 'order: 1' : ''"
              color="success"
              dark
              depressed
              min-width="100"
              @click="showPause('active')"
            >
              {{ $t("activate") }}
              <v-icon class="ms-1" small>mdi-reload</v-icon>
            </v-btn>
            <help-info
              :element-name="`${serviceName}-${componentName}-btn-active-ismobile`"
              :help-data="helpData"
              :label="$t('activate')"
              :service-name="serviceName"
              class="buttoninfo"
            />
          </div>

          <div
            class="more-actions desc-text pa-2 mx-auto"
            style="
              width: 100%;
              align-self: center;
              align-content: center;
              justify-content: center;
              justify-items: center;
            "
          >
            <router-link
              v-if="
                permissionState.edit_info ||
                ![
                  'qr.name.productPro',
                  'qr.name.id.productPro',
                  'qr.name.id.editPdf',
                  'qr.name.editPdf',
                ].includes($route.name)
              "
            :to="{ path: findEditPage(info?.domain?.name, info.identifier, info.type, info.qrId) }"

              class="d-inline-block"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    :to="
                      findEditPage(
                        info?.domain?.name,
                        info.identifier,
                        info.type,
                        info.qrId?.replace('?gateway=true',''),
                      )
                    "
                  >
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("edit") }}</span>
              </v-tooltip>
            </router-link>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="permissionState.edit_design"
                  icon
                  small
                  v-bind="attrs"
                  @click="
                    goto(
                      ['qrLink','clickyarseo'].includes(info?.type?.trim())
                        ? `qr/design2/${!!info.qrId?.replace('?gateway=true','') ? info.qrId?.replace('?gateway=true','') : ''}`
                        : `qr/design/${info.domain?.name}${
                            !!info.identifier ? info.identifier : ''
                          }`,
                    )
                  "
                  v-on="on"
                >
                  <v-icon small>mdi-palette</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("design") }}</span>
            </v-tooltip>

            <v-tooltip v-if="info.status === 'active'" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="permissionState.edit_settings"
                  icon
                  small
                  v-bind="attrs"
                  @click="
                    ['qrLink','clickyarseo'].includes(info?.type?.trim())
                      ? goto(`qr/setting2/${info.qrId?.replace('?gateway=true','')}`)
                      : goto(
                          `qr/setting/${info.domain.name}${
                            !!info.identifier ? info.identifier : ''
                          }`,
                        )
                  "
                  v-on="on"
                >
                  <v-icon small>mdi-cogs</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("qr_settings") }}</span>
            </v-tooltip>

            <v-tooltip v-if="info.status === 'active'" bottom color="warning">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="permissionState.toggle_access"
                  color="warning"
                  icon
                  small
                  v-bind="attrs"
                  @click="showPause('deactivate')"
                  v-on="on"
                >
                  <v-icon small>mdi-pause</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("deactivate") }}</span>
            </v-tooltip>

            <v-tooltip v-else bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  v-bind="attrs"
                  @click="$root.$emit('fillInfo', info)"
                  v-on="on"
                >
                  <v-icon small>mdi-download</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("download") }}</span>
            </v-tooltip>

            <!--        <v-tooltip bottom color="red darken-1">-->
            <!--          <template v-slot:activator="{on, attrs}">-->
            <!--            <v-hover v-slot="{ hover }">-->
            <!--              <v-btn :color="hover ? 'red darken-2' : ''" icon small v-bind="attrs" @click="showDestroy"-->
            <!--                     v-on="on">-->
            <!--                <v-icon small>mdi-delete</v-icon>-->
            <!--              </v-btn>-->
            <!--            </v-hover>-->
            <!--          </template>-->

            <!--          <span>حذف</span>-->
            <!--        </v-tooltip>-->
          </div>
        </v-card-actions>
      </v-card>
    </template>

    <custom-popup
      v-model="bshop_mang_pop"
      :cons="{ title: $t('manage_products') }"
      hide-confirm
      hide-overlay
      max-width="900"
      transition="dialog-bottom-transition"
    >
      <v-card class="px-5 py-4">
        <v-row no-gutters>
          <!-- دکمه دانلود محصولات -->
          <v-col cols="12">
            <v-alert border="left" color="success" colored-border elevation="2">
              <v-btn
                :loading="downloadLoading"
                class="text-break"
                color="success"
                text
                @click="downloadProducts"
              >
                <v-icon color="success" right>mdi-download</v-icon>
                {{ $t("products_export") }}
              </v-btn>
            </v-alert>
          </v-col>
          <!-- آپلودر فایل -->
          <v-col class="mt-4" cols="12">
            <v-card
              id="uploader"
              ref="uploader"
              class="mx-auto d-flex justify-center align-center rounded-xl flex-column overflow-hidden"
              height="200"
              outlined
              @click="dragEvent"
              @dragleave="dragEvent"
              @dragover="dragEvent"
              @drop="dragEvent"
            >
              <v-icon size="68" style="opacity: 0.4"
                >mdi-cloud-upload-outline
              </v-icon>
              <v-card-title class="justify-center"
                >{{ $t("UPLOAD_EXCEL.UPLOAD_TITLE") }}
              </v-card-title>
              <v-card-text class="text-center pt-0 text-break">
                {{ $t("UPLOAD_EXCEL.DRAG_DROP_TEXT_PART1") }}
                <v-btn class="mx-1" color="primary" min-width="75" small>
                  {{ $t("UPLOAD_EXCEL.DRAG_DROP_TEXT_PART2") }}
                </v-btn>
                {{ $t("UPLOAD_EXCEL.DRAG_DROP_TEXT_PART3") }}
              </v-card-text>
            </v-card>
          </v-col>
          <!-- نمایش فایل انتخاب‌شده -->
          <v-col class="mt-3" cols="12">
            <v-card
              v-show="!!filesPreview && !!filesPreview.length"
              :loading="upLoading"
              class="mx-auto pa-2 rounded-lg"
              flat
              outlined
            >
              <div
                v-for="(item, i) in filesPreview"
                :key="i"
                class="pa-1 text-center"
              >
                <v-list-item>
                  <v-list-item-avatar
                    :color="item.color || 'success'"
                    class="white--text"
                    size="64"
                  >
                    <v-icon
                      >mdi-{{
                        !!item.color
                          ? !!item.status
                            ? "check"
                            : "close"
                          : "check"
                      }}
                    </v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <div
                      v-if="!upLoading && (!item.status || !item.color)"
                      class="text-left fill-height"
                    >
                      <v-btn icon @click="removeFileFromUpload">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </v-list-item-action>
                </v-list-item>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-card-actions class="justify-end mt-4">
          <v-btn
            :disabled="!excelFile"
            :loading="upLoading"
            color="primary"
            depressed
            @click="sendFile"
          >
            {{ $t("GENERAL.SUBMIT") }}
          </v-btn>
          <v-btn color="error" text @click="bshop_mang_pop = false">
            {{ $t("GENERAL.CANCEL") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </custom-popup>
  </help-info-wrapper>
</template>

<script>
import HelpInfo from "../../../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import { mapGetters, mapActions } from "vuex";
import progress_createauto from "../../../robot/autoCard/progress_createauto.vue";
import renewButton from "../../../qrland/components/renewButton.vue";
import { ir } from "../../../../../check_domain_ir";

export default {
  name: "cardListUser",

  components: {
    HelpInfo,
    HelpInfoWrapper,
    progress_createauto,
    renewButton,
  },

  props: {
    info:Object,
    showCheck: Boolean,
    value: Boolean,
    priceLoading: Boolean,
    imageLoadingFromParent: Boolean,
  },

  data: () => ({
      displayMap: {
        'qreitaa': { type: 'image', src: '/media/socialnetwork/icon/eitaa.png' ,name:"ایتا"},
        'qrbale': { type: 'image', src: '/media/socialnetwork/icon/bale.png' ,name:"بله"},
        'qrrobika': { type: 'image', src: '/media/socialnetwork/icon/robika.png' ,name:"روبیکا"}
      },
    downloadLoading: false,
    bshop_mang_pop: false,
    excelFile: null,
    filesPreview: [],
    upLoading: false,
    downloadSampleUrl: "/assets/xlsx/products_template.xlsx",
    helpData: [],
    imageKey: 0,
    serviceName: "Qrland",
    componentName: "cardlistuser",
    editTitle: false,
    editedName: "",
    errorMessage: null,
    showTooltip: false,
    checkbox: false,
    loading: false,
    pickedUser: null,
    permissions: null,
    imageLoading: true,
  }),

  mounted() {
    this.editedName = this.info.title;
    this.setCreatedQrID(this.info.id);
  },
     
 
  computed: {
        permissionState() {
    const permissions = this.permissions || {};

    return {
      editDesign: !permissions.edit_design,
      editInfo: !permissions.edit_info,
      editSettings: !permissions.edit_settings,
      toggleAccess: !permissions.toggle_access,
      viewCustomers: !permissions.view_customers,
      viewOrders: !permissions.view_orders,
      qrId: permissions.qr_id !== this.info.id,
      edit_name: !permissions.edit_name,
      edit_link: !permissions.edit_link,
    };
  },
    validHref() {
    let link = this.info?.dest_link ?? this.qrLink;
    
    if (!link) return '#';

    if (!/^https?:\/\//i.test(link)) {
      return `https://${link}`;
    }
    
    return link;
  },
    daysRemaining() {
      return this.getUntilExpire(this.getExpireAt);
    },

    renewBadgeText() {
      return this.getTypeText(this.daysRemaining, true);
    },

    renewButtonColor() {
      const colorClass = this.$options.filters.expireColor(this.daysRemaining);
      const colorMap = {
        "": "green darken-1",
        "in-month": "amber darken-2",
        "in-days": "amber darken-3",
        "in-expire": "red darken-2",
      };
      return colorMap[colorClass] || "red darken-2";
    },

    renewBadgeColor() {
      const colorClass = this.$options.filters.expireColor(this.daysRemaining);
      const colorMap = {
        "": "green darken-2",
        "in-month": "amber darken-3",
        "in-days": "orange lighten-1",
        "in-expire": "red darken-3",
      };
      return colorMap[colorClass] || "red darken-2";
    },
    authToken() {
      return localStorage.getItem("id_token");
    },
    exportLang() {
      return this.$i18n.locale;
    },
    ...mapGetters("ribbon", ["user"]),
    isImageLoading() {
      return this.imageLoadingFromParent || this.imageLoading;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    qrLink() {
      let link = this.info.domain?.name || "";
      let token = localStorage.getItem("id_token");
      if (!link.startsWith("http")) {
        link = "https://" + link;
      }

      if (!!this.info?.identifier) return link + this.info.identifier;
      return link;
    },
    qrSmsLink() {
      let user = this.user?.name ?? "";
      let link = "";

      if (this.user?.family) user += " " + this.user.family;
      if (this.info.domain?.name)
        link = this.info.domain.name + this.info.identifier ?? "";

      let token = localStorage.getItem("id_token");

      let patternId = "";
      switch (this.info.type) {
        case "VisitCard":
        case "visitcardpro":
          patternId = 244;
          break;
        case "menu":
          patternId = 246;
          break;
        default:
          patternId = 467;
          break;
      }

      return `${this.$services[2]}/?token=${token}#/patternSms?link=${link}&pattern=${patternId}&user=${user}`;
    },
    displayLink() {
      let rgx = /^(http|https):\/\//gm;
      return this.info?.dest_link??this.qrLink.split("?")[0].replace(rgx, "");
    },
    gotoGraphic() {
      let token = localStorage.getItem("id_token");
      return `${this.$services[14]}/?token=${token}#/visit/card`;
    },
    getExpireAt() {
      return this.info.expire_at;
    },
    getImage() {
      return this.info.img_url === null
        ? (this.$rootUrl || this.$qrUrl + "/") + `qr/${this.info.image}`
        : ir(this.info.img_url);
      // return `https://qr-api.terminalads.com/qr/${this.info.image}`
      // return `http://127.0.0.1:8001/qr/${this.info.image}`
    },
  },

  watch: {
    "info.title"(val) {
      this.editedName = val;
    },
    info: {
      deep: true,
      async handler(val) {
        if (val) {
          this.permissions = val.permissions;
            if (val.user_register !== undefined) {
            this.setRegisterOnline(val.user_register);
          }

          this.imageLoading = true;
          try {
            await new Promise((resolve, reject) => {
              const img = new Image();
              img.src = this.getImage;
              img.onload = resolve;
              img.onerror = reject;
            });
            this.imageLoading = false;
          } catch (error) {
            this.imageLoading = false;
          }
        } else {
          this.permissions = null;
          this.imageLoading = false;
        }
      },
    },
    showTooltip(val) {
      if (val) {
        setTimeout(() => {
          this.showTooltip = false;
        }, 2000);
      }
    },
    value(val) {
      this.checkbox = val;
    },
    checkbox(val) {
      this.$emit("input", val);
    },
    editTitle(val) {
      if (val) {
        this.editedName = this.info.title;
      }
    },
    imageLoadingFromParent(val) {
      this.imageLoading = val;
    },
    getImage(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.imageLoading = true;
        this.imageKey++;
      }
    },
  },

  methods: {
    ...mapActions("localstorage", [
      "setCreatedQrID",
      "setQrType",
      "setRegisterOnline",
      "updateQrId"
    ]),

    downloadExcel() {
      this.$toast.warning("به زودی");
    },
    dragEvent(e) {
      e.stopPropagation();
      e.preventDefault();
      let uploader = this.$refs.uploader;

      if (
        e.type === "dragover" &&
        !uploader.$el.classList.contains("drag-over")
      )
        uploader.$el.classList.add("drag-over");
      else if (
        e.type === "dragleave" &&
        uploader.$el.classList.contains("drag-over")
      )
        uploader.$el.classList.remove("drag-over");
      else if (e.type === "drop") {
        uploader.$el.classList.remove("drag-over");
        const files = e.target.files || e.dataTransfer.files;
        if (
          files[0] &&
          files[0].type ===
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        ) {
          this.excelFile = files[0];
          this.handleFileUpload(files[0]);
        } else {
          this.$toast.error(
            this.$t("UPLOAD_EXCEL.INVALID_FILE_TYPE") ||
              "لطفاً فقط فایل اکسل (.xlsx) آپلود کنید",
          );
        }
      } else if (e.type === "click") {
        const input = document.createElement("input");
        input.type = "file";
        input.accept = ".xlsx";
        input.onchange = (event) => {
          const file = event.target.files[0];
          if (
            file &&
            file.type ===
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          ) {
            this.excelFile = file;
            this.handleFileUpload(file);
          } else {
            this.$toast.error(
              this.$t("UPLOAD_EXCEL.INVALID_FILE_TYPE") ||
                "لطفاً فقط فایل اکسل (.xlsx) آپلود کنید",
            );
          }
        };
        input.click();
      }
    },
    handleFileUpload(file) {
      if (file) {
        this.filesPreview = [{ name: file.name }];
        this.$forceUpdate();
      }
    },
    removeFileFromUpload() {
      this.filesPreview = [];
      this.excelFile = null;
      this.$forceUpdate();
    },
    async sendFile() {
      if (!this.excelFile || !this.authToken || !this.info.qrId) {
        this.$toast.error(
          this.$t("GENERAL.ERROR") || "خطا: فایل، توکن یا شناسه QR معتبر نیست",
        );
        return;
      }

      this.upLoading = true;
      const data = new FormData();
      data.append("file", this.excelFile);
      data.append("qr_id", this.info.id);
      console.log(this.excelFile, this.info.id, this.info, "values");

      try {
        const response = await this.$api.post(
          "/v1/testQr/importBShopQrProduct",
          data,
        );
        this.$toast.success(
          response.data?.message ||
            this.$t("GENERAL.SUCCESSFULLY_ADDED") ||
            "محصولات با موفقیت آپلود شد",
        );
        this.bshop_mang_pop = false;
        this.removeFileFromUpload();
        this.$emit("fetch");
      } catch (error) {
        console.error("Failed to import products:", error);
        const errorMsg =
          error.response?.data?.message ||
          this.$t("GENERAL.ERROR") ||
          "خطا در آپلود محصولات";
        this.$toast.error(errorMsg);
      } finally {
        this.upLoading = false;
      }
    },
    async downloadProducts() {
      if (!this.authToken || !this.info.qrId) {
        this.$toast.error(
          this.$t("GENERAL.ERROR") || "خطا: توکن یا شناسه QR معتبر نیست",
        );
        return;
      }

      this.downloadLoading = true;
      const params = {
        qr_id: this.info.id,
        lang: this.exportLang,
      };

      try {
        const response = await this.$api.get(
          "/v1/testQr/exportBShopQrProduct",
          {
            params,
            headers: {
              Authorization: `Bearer ${this.authToken}`,
            },
          },
        );

        if (response.data.status && response.data.data.url) {
          const url = response.data.data.url;
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `bshop_products_${this.info.qrId}.${this.exportLang}.xlsx`,
          );
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          this.$toast.success(
            response.data.message ||
              this.$t("SUCCESSFULLY_DOWNLOADED") ||
              "محصولات با موفقیت دانلود شد",
          );
        } else {
          throw new Error("Invalid response format");
        }
      } catch (error) {
        console.error("Failed to export products:", error);
        const errorMsg =
          error.response?.data?.message ||
          this.$t("GENERAL.ERROR") ||
          "خطا در دانلود محصولات";
        this.$toast.error(errorMsg);
      } finally {
        this.downloadLoading = false;
      }
    },

    ///
    onImageLoad() {
      this.imageLoading = false;
    },
    onImageError() {
      this.imageLoading = false;
    },
    hasValidHelpinfo(elementName) {
      if (
        (!this.helpData ||
          !Array.isArray(this.helpData) ||
          this.helpData.length === 0) &&
        !this.ribbon_can("guideuser")
      ) {
        return false;
      }
      const itemElement = this.helpData?.find(
        (p) =>
          p.name &&
          typeof p.name === "string" &&
          p.name.trim() === (elementName?.trim() || ""),
      );
      return itemElement || this.ribbon_can("guideuser");
    },
    findEditPage(name, id, type, qrid) {
      qrid=qrid?.replace('?gateway=true','');
      const types = {
        visitcard: `/qr/edit/${name}${!!id ? id : ""}`,
        visitcardpro: `/qr/editpro/${name}${!!id ? id : ""}`,
        business: `/qr/editBpage/${name}${!!id ? id : ""}`,
        goldlabel: `/qr/goldlabel/${name}${!!id ? id : ""}`,
        commericial: `/qr/editCpage/${name}${!!id ? id : ""}`,
        qrlink: `/qr/link/${!!qrid ? qrid : ""}`,
        clickyarseo: `/qr/linkpro/${!!qrid ? qrid : ""}`,
        socialmedia: `/qr/editSocial/${name}${!!id ? id : ""}`,
        consultationqr: `/qr/consultationQrEdit/${name}${!!id ? id : ""}`,
        videogallery: `/qr/editVideo/${name}${!!id ? id : ""}`,
        voicegallery: `/qr/editVoice/${name}${!!id ? id : ""}`,
        voicegallerypro: `/qr/editVoicePro/${name}${!!id ? id : ""}`,
        feedbackgallery: `/qr/editFeedback/${name}${!!id ? id : ""}`,
        photogallery: `/qr/editPhoto/${name}${!!id ? id : ""}`,
        singleproduct: `/qr/product/${name}${!!id ? id : ""}`,
        labelproduct: `/qr/labelproduct/${name}${!!id ? id : ""}`,
        menu: `/qr/editMenu/${name}${!!id ? id : ""}`,
        bshop: `/qr/editBShop/${name}${!!id ? id : ""}`,
        appointment: `/qr/editAppointment/${name}${!!id ? id : ""}`,
        application: `/qr/editApplication/${name}${!!id ? id : ""}`,
        insurance: `/qr/insurance/${name}${!!id ? id : ""}`,
        wheel: `/qr/luck-wheel/${name}${!!id ? id : ""}`,
        multicard: `/qr/multicard/${name}${!!id ? id : ""}`,
        productpro: `/qr/productPro/${name}${!!id ? id : ""}`,
        pdfgallery: `/qr/editPdf/${name}${!!id ? id : ""}`,
        catalog: `/qr/editcatalog/${name}${!!id ? id : ""}`,
        gift: `/qr/editgift/${name}${!!id ? id : ""}`,
        text: `/qr/editText/${name}${!!id ? id : ""}`,
        qrbale:`/qr/editBale/${name}${!!id ? id : ""}`,
        qrrobika:`/qr/editRobika/${name}${!!id ? id : ""}`,
        qreitaa:`/qr/editEitaa/${name}${!!id ? id : ""}`,
        pricelabel: `/qr/labelprice/${name}${!!id ? id : ""}`,
        attendanceqr: `/qr/editattendance/${name}${!!id ? id : ""}`,     


      };
      const excludedTypes = ['attendanceqr','bankcard','pricelabel','qrbale','qrrobika','qreitaa','text','consultationqr','appointment','application','wheel','labelproduct','bshop','insurance','multicard','feedbackgallery','singleproduct','voicegallerypro','catalog','voicegallery','productpro','commericial','goldlabel','visitcard', 'visitcardpro', 'gift',"videogallery", "socialmedia", "photogallery","pdfgallery","menu", "business"];
      if (!excludedTypes.includes(type?.trim()?.toLowerCase())) {
      return types[type?.toLowerCase()]?.replace('?gateway=true','');
      }
      return `${types[type?.toLowerCase()]?.replace('?gateway=true','')}?gateway=true`;

      // this.goto(types[type]);
    },
    copyUrl() {
      if (["qrLink","clickyarseo"].includes(this.info?.type?.trim())) {
        if (navigator.clipboard) {
          navigator.clipboard
            .writeText(this.info?.dest_link)
            .then(() => {
              this.showTooltip = true;
            })
            .catch((err) => {
              console.error("Clipboard error:", err);
            });
        } else {
          const textarea = document.createElement("textarea");
          textarea.value = this.info?.dest_link;
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand("copy");
          document.body.removeChild(textarea);
          this.showTooltip = true;
        }
      } else if (this.info.domain) {
        if (navigator.clipboard) {
          navigator.clipboard
            .writeText(this.qrLink)
            .then(() => {
              this.showTooltip = true;
            })
            .catch((err) => {
              console.error("Clipboard error:", err);
            });
        } else {
          const textarea = document.createElement("textarea");
          textarea.value = this.qrLink;
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand("copy");
          document.body.removeChild(textarea);
          this.showTooltip = true;
        }
      }
    },
    onCloseField() {
      this.errorMessage = null;
      this.editTitle = false;
    },
    updateTitle() {
      if (!this.editedName || this.editedName.length <= 0) {
        this.errorMessage = "نام کارت ویزیت را به درستی وارد نمایید!";
        return;
      }

      this.loading = true;
      this.$api
        .put(
          "/v1/testQr/update",
          ["qrLink","clickyarseo"].includes(this.info?.type?.trim())
            ? {
                qr_id: this.info?.qrId?.replace('?gateway=true',''),
                title: this.editedName,
                type:this.info?.type?.trim(),
              }
            : {
                qr_id: this.info?.qrId?.replace('?gateway=true',''),
                domain: this.info?.domain?.name  || "qrland.in",
                identifier: this.info?.identifier || "",
                title: this.editedName,
              },
        )
        .then(({ data }) => {
          this.onCloseField();
          this.info.title = this.editedName;
        })
        .finally(() => (this.loading = false));
    },

    async showDestroy() {
      if (await this.$modal.yesNo("آیا از حذف کیوآر مطمئن هستید؟")) {
        this.destroy();
      }
    },
    destroy() {
      this.loading = true;

      this.$api
        .delete(`/v1/testQr/delete`, {
          params:
          ["qrLink","clickyarseo"].includes(this.info?.type?.trim())              ? {
                  qr_id: this.info?.id,
                }
              : {
                  domain: this.info.domain?.name || "",
                  identifier: this.info?.identifier || "",
                },
        })
        .then(({ data }) => {
          this.$toast.success("کیوآر با موفقیت حذف شد.");
          this.$emit("fetch");
        })
        .catch(({ response }) => console.log("error in delete qr: ", response))
        .finally(() => (this.loading = false));
    },

    async showPause(input) {
      let msg =
        input === "deactivate"
          ? "آیا از متوقف کردن کیوآر مطمئن هستید؟"
          : "آیا از فعال کردن کیوآر مطمئن هستید؟";
      if (await this.$modal.yesNo(msg)) {
        this.disable(input);
      }
    },
    disable(input) {
      this.loading = true;

      this.$api
        .put(
          "/v1/testQr/update",
          ["qrLink","clickyarseo"].includes(this.info?.type?.trim())
            ? {
                qr_id: this.info.qrId?.replace('?gateway=true',''),
                status: input,
              }
            : {
                qr_id: this.info.qrId?.replace('?gateway=true',''),
                domain: this.info.domain?.name || "",
                identifier: this.info.identifier || "",
                status: input,
              },
        )
        .then(({ data }) => {
          let s = { active: "فعال", deactivate: "متوقف" };
          this.$toast.success(`کیوآر با موفقیت ${s[input]} شد.`);
          this.$emit("fetch");
        })
        .catch(({ response }) => console.log("error in paused qr: ", response))
        .finally(() => (this.loading = false));
    },

    getPrices() {
      this.$root.$emit("getPrices", this.info);
    },
    transferUser(e) {
      this.loading = true;

      this.$api
        .put(
          "/admin/transfer-qr",
          {},
          {
            params: {
              qr: this.info.id,
              user: e,
            },
          },
        )
        .then(({ data }) => {
          if (
            data &&
            data.status &&
            (data.status === true || data.status === "200")
          ) {
            this.$toast.success("کاربر با موفقیت انتقال یافت");
            this.$refs.userPicker.dialog = false;
          } else {
            this.$toast.error("مشکلی در انتقال رخ داده است!");
          }
        })
        .catch(({ response }) => {
          this.$toast.error("خطا در انتقال کاربر!");
        })
        .finally(() => (this.loading = false));
    },
    qrUpdate(final = false) {
      this.loading = true;

      const data = new FormData();
      data.append("domain", this.info?.domain?.name);
      data.append("identifier", this.info?.identifier || "");
      data.append("_method", "PUT");
      data.append("image", this.qrSvgDataUrl);
      data.append("qr", JSON.stringify(this.qrDesign));
      data.append("qr_id", this.info.qrId?.replace('?gateway=true',''));

      this.$api
        .post("/v1/testQr/update", data, {
          headers: {
            "Content-Type": "application/from-data",
          },
        })
        .then((res) => {
          this.finish = final;
          this.goto("qr/list");
          this.$toast.success("کیوآر شما باموفقیت ویرایش شد.");
        })
        .catch((err) => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    Participation() {
      let type = this.info?.type?.toLowerCase();
      this.$api
        .get(
          type === "commericial"
            ? `${this.$qrApi}/v1/commercial/${this.info.id}`
            : `${this.$qrApi}/v1/commercial/user?qr=${this.info.id}`,
        )
        .then(({ data }) => {});
    },
    choseNfc() {
      // let type = this.info.type.toLowerCase();
      // if (
      //   type === "labelproduct" ||
      //   type === "feedback" ||
      //   type === "qrlink" ||
      //   type === "voicegallery" ||
      //   type === "feedbackgallery" ||
      //   type === "multicard" ||
      //   type === "consultationqr" ||
      //   type === "voicegallerypro"
      // ) {
      //   return false;
      // } else {
      return true;
      // }
    },
  },
};
</script>

<style scoped>
.v-card {
  background-color: #f5f5f5;
  border-radius: 8px;
  padding: 16px;
}

.v-divider {
  margin: 16px 0;
}

.v-list-item {
  padding: 0;
}

.v-list-item-content {
  margin-left: 0;
}

.v-btn {
  text-transform: none;
}

.v-tab--active {
  border-bottom: 2px solid var(--v-primary-base);
}

@media screen and (min-width: 960px) {
  .qr-card-wrapper:hover >>> .more-actions,
  .qr-card-wrapper:hover >>> .action-select,
  .qr-card-wrapper >>> .action-select.show-checkbox {
    visibility: visible !important;
  }

  .qr-card-wrapper:hover >>> .icon-list-type {
    transition: all 0.25s ease-in-out;
    transform: scale(1.1);
  }

  .expire-option {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateY(calc(-100% - 10px)) translateX(-50%);
  }

  .action-select {
    position: absolute;
    right: 0;
    top: 0;
    visibility: hidden;
    height: 100%;
    z-index: 2;
  }

  .more-actions {
    visibility: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    transform: translateY(calc(100% + 5px));
  }
}

.qr-card-wrapper.in-expire {
  border: 1px solid rgb(255, 11, 11);
  box-shadow: none !important;
}

.expire-option {
  width: 100%;
  white-space: nowrap;
  padding: 2px 8px;
  text-align: center;
  border-radius: 4px;
  background-color: forestgreen;
  color: white;
}

.expire-option.in-month {
  background-color: var(--v-warning-base);
}

.expire-option.in-days {
  background-color: darkorange;
}

.expire-option.in-expire {
  background-color: var(--v-third-base);
}

.desc-text,
.desc-text >>> a,
.desc-text >>> .v-icon:not(:hover) {
  color: #c2c2c2;
}

.w-fit-content {
  width: fit-content;
}

.rowinfo {
  display: flex !important;
  flex-direction: row !important;
  gap: 0 !important;
  justify-content: flex-start !important;
  margin: 0 !important;
  align-items: center !important;
  flex-wrap: nowrap !important;
}

.contentinfo {
  flex: 1 1 auto !important;
  padding: 0 !important;
  margin: 0 !important;
  display: flex;
  align-items: center !important;
}

.buttoninfo {
  flex: 0 0 30px !important;
  padding: 0 !important;
  margin: 0 !important;
  max-width: 30px !important;
  align-self: center !important;
}

.disabled {
  pointer-events: none;
  opacity: 0.5;
  filter: blur(2px);
  box-shadow: none;
  transition: all 0, 3s ease;
  cursor: not-allowed;
  animation: fade 2.5s infinite;
}

.disabled:hover {
  transform: scale(0.98);
}

@keyframes fade {
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 0.6;
  }
}

.v-progress-circular {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.imgLoading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.nfc-loading-overlay {
  animation: fadeInOut 0.3s ease-in-out;
  backdrop-filter: blur(2px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

@keyframes fadeInOut {
  0% {
    opacity: 0;
    transform: scale(0.95);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@media screen and (max-width: 576px) {
  .contentinfo {
    margin-top: 3rem !important;
  }
}

.v-tooltip__content {
  z-index: 9999 !important;
}
.full-width-btn {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 100% !important;
}

.full-width-btn >>> .v-btn {
  width: 100% !important;
}

.full-width-btn >>> .renew-button {
  width: 100% !important;
}
</style>
